import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../features/auth/authSlice"; 

const INACTIVITY_MS = 2 * 60 * 60 * 1000; // 2 hours
// const INACTIVITY_MS = 10 * 1000; // 10 s

export const useAutoLogoutOnInactivity = () => {
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth.token);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!token) return; // only track when logged in

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        dispatch(logout());
      }, INACTIVITY_MS);
    };

    // Events that count as "activity"
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

    events.forEach((e) => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer(); // start timer immediately on login

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [token, dispatch]);
}